
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Activity, { ActivityProps, fetchActivityPageData } from 'library/pages/Activity';
import { GetStaticProps } from 'next';
/**
 * Please think of this as a root page for the pages relating to configuring and making a booking
 *
 * The first page of the flow will be for displaying the details of the activity
 *
 * Other pages are to be hit via changing 'views'
 *
 * Note - we went with this view changing approach because we didn't want this driven by Url's via
 * Next.
 *
 */
const ActivityPage = (props: ActivityProps) => <Activity {...props}/>;
export default ActivityPage;
export const getStaticPaths = async () => {
    return {
        paths: [],
        fallback: 'blocking'
    };
};
const getStaticProps: GetStaticProps = async ({ params, locale }) => {
    const data = await fetchActivityPageData({
        widgetSlug: params?.widgetSlug as string,
        activitySlug: params?.activitySlug as string,
        locale: locale as string
    }).fetch();
    const outlet = data?.outlet;
    const activity = data?.activity;
    return {
        props: {
            outlet,
            activity
        },
        revalidate: 1,
        notFound: !outlet || !activity
    };
};

    async function __Next_Translate__getStaticProps__1961a27c887__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[widgetSlug]/[categorySlug]/[activitySlug]/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1961a27c887__ as getStaticProps }
  